// Constants
export const VEHICLE_DROPDOWN_SELECTOR = "[data-vehicle-dropdown]";
export const MIN_CYCLES = 1;

// Utility functions (testable)
export const isClickOutsideElement = (
  target: Element,
  selector: string
): boolean => {
  const element = document.querySelector(selector);
  return element ? !element.contains(target) : true;
};

export const calculateNewCycles = (
  currentCycles: number,
  operation: "increase" | "decrease"
): number => {
  if (operation === "increase") {
    return currentCycles + 1;
  }
  return Math.max(MIN_CYCLES, currentCycles - 1);
};

export const getDisplayVehicleName = (
  selectedVehicle: Vehicle | null,
  vehicleName: string
): string => {
  return selectedVehicle?.name || vehicleName || "Select a Vehicle";
};
